export const reloadPage = (url: string) => {
  // Check if the URL is the same as the current one and force a reload if it is
  if (window.location.href === url) {
    window.location.reload();
  } else {
    window.location.href = url;
  }
};
